(function(){
     'use strict';

     angular
        .module('app')
        .factory('AnimalesService', AnimalesService);

    AnimalesService.$inject = ['$http'];

    function AnimalesService($http){

        var service= {
           getAnimalesCentro:getAnimalesCentro,
           getAnaliticas:getAnaliticas,
           getAnaliticasByPaciente:getAnaliticasByPaciente,
           guardarPaciente:guardarPaciente,
           getAnimalByMuestra:getAnimalByMuestra,
           getAnimalById:getAnimalById,
           getMuestrasByAnimal:getMuestrasByAnimal,
           getCategoriasEspecies:getCategoriasEspecies,
           buscarAnimalesRel:buscarAnimalesRel,
           intercambiarAnimal:intercambiarAnimal
           
        };

        return service;

        function intercambiarAnimal(animal_new_id,animal_old_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               animal_new_id:animal_new_id,
               animal_old_id:animal_old_id,
               lang_id:lang_id
            });
            $http.post('/uranolab/intercambiaranimal', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
        function buscarAnimalesRel(animal_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/buscaranimalesrel', { params : { animal_id:animal_id,lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getAnimalesCentro(peticionEdicion,filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanimalescentro', { params : { peticionEdicion:peticionEdicion,filtros : filtros,lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getMuestraAnimalYMuestras(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getmuestraanimalymuestras', { params : { lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getCategoriasEspecies(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getcategoriasespecies', { params : { lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnimalByMuestra(muestra,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           

            $http.get('/uranolab/getanimalbymuestra', { params : { muestra_id : muestra.id, id_animal:muestra.animal_id,lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getAnimalById(animal_id,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           

            $http.get('/uranolab/getanimalbymuestra', { params : { id_animal:animal_id, lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }


        function getMuestrasByAnimal(animal,callback){
             var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           

            $http.get('/uranolab/getmuestrasbyanimal', { params : { animal_id : animal.id, centro_id:animal.centro_id, lang_id:lang_id } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnaliticas(peticionEdicion,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanaliticas', { params : { peticionEdicion:peticionEdicion,lang_id:lang_id }}, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getAnaliticasByPaciente(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getanaliticas', { params : { filtros:filtros,lang_id:lang_id }}, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarPaciente(newpaciente,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            console.log(newpaciente);
            var data = $.param({
               paciente:JSON.stringify(newpaciente),
               lang_id:lang_id
            });
            $http.post('/uranolab/guardarpaciente', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }
    }
})();